const bar = document.querySelector('.impact-bar');
if (!bar) return;

// Configuration: change these to the store/namespace/key you want
  const store = "organicup-allmatters";
  const namespace = "custom";
  const key = "impact_campaign_quantity_reached";


// Function to fetch metafield data
  async function fetchMetafield() {
    try {
      const url = `https://netlify.blacklemon.dk/.netlify/functions/getShopMetafields?store=${store}&namespace=${namespace}&key=${key}`;
      const response = await fetch(url);
      const data = await response.json();

      if (data?.metafield) {
        console.log("Metafield data returned", data.metafield.value);
        displayMetafield(data.metafield.value);
      } else {
        console.warn("No metafield data returned", data);
      }
    } catch (error) {
      console.error("Error fetching metafield:", error);
    }
  }


  // Function to display metafield value on page
  function displayMetafield(metafield) {
    const goal = bar.dataset.goal;
    let progress = (Number(metafield) / Number(goal) * 100).toFixed(0);
    if (progress > 100) {
      progress = 100;
      console.log("Progress is greater than 100");
    }
    bar.querySelector('.impact-bar__progress-inner').style.width = progress + '%';
    bar.querySelector('.impact-bar__tooltip').style.left = progress + '%';
    bar.querySelector('.impact-bar__tooltip span').innerHTML = progress;
    bar.querySelector('.impact-bar__percentage-to-goal span').innerHTML = progress;
  }

  fetchMetafield();

  // Repeat fetch every 15 seconds
  setInterval(fetchMetafield, 15000);